<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { Table } from "../../components/Table";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import { initList, load, initDetail, loading, records, record, save, onEdit, onDelete, editing } from "./recipe-materials.store";
  import { recipeMaterialDtoFields } from "../../utils/TableFields/recipe-material-dto.fields";

  export let recipeId: number;

  $: isNew = $record != null && $record.oid == 0;
  $: canSubmit = $record != null && !!$record.clfMaterialTypeId && $record.quantity > 0;

  async function onSubmit() {
    await save();
    initDetail();
    load();
  }

  function onCancel() {
    initDetail();
    load();
  }

  onMount(() => initList(recipeId));
</script>

{#if !!recipeId && !!$record}
  <div class="columns" style="height: unset;">
    <div class="column is-12">
      <FormLayout {canSubmit} {isNew} createButtonText="Aggiungi" on:submit={onSubmit} on:cancel={onCancel}>
        <div class="columns">
          <div class="column is-6">
            <FormField>
              <ClfDropdown name="Materiale" placeholder="materiale" schema="MATERIALSX" required={true} bind:value={$record.clfMaterialTypeId} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <NumberInput name="Quantità" placeholder="" minValue={0} required={true} bind:value={$record.quantity} />
            </FormField>
          </div>
        </div>
      </FormLayout>
    </div>
  </div>

  <Table
    loading={$loading}
    fields={recipeMaterialDtoFields}
    records={$records}
    createEnabled={false}
    editEnabled={true}
    deleteEnabled={true}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
  />
{/if}
